// @flow

//
// React
//
import React from 'react';

//
// Material UI
//
import Typography from '@mui/material/Typography';

import { makeStyles } from '@mui/styles';

import clsx from 'clsx';

//
// Styles
//
const useStyles = makeStyles(theme => ({
    root: {
        fontSize: '0.875rem',
    },

    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        '&:hover': {
            cursor: 'pointer',
        },
    },
}));

//
// Props
//
type Props = {
    //
    // Data
    //
    item: any,
}

//
// Component
//
const TrackingTimelineItem = (props: Props) => {
    //
    // Hooks
    //
    const classes = useStyles();
    // End hooks

    return(
        <div className={classes.root}>
            <div><b>{props.item.operation.type}</b> {props.item.operation.message}</div>
            <div>{props.item.description}</div>
            {(props.item.location) ? `Локация: ${props.item.location}` : ''}
            {(props.item.errors || []).map(error => (<div>Причина: <b>{error.type}</b> {error.message}</div>))}
        </div>
    );
};
export default TrackingTimelineItem;
